import React from 'react';
import './radioPicker.scss';
import Typography from '../../components/Typography';
import classNames from 'classnames';
import COLORS from '../../util/constants/colors';

const RadioPicker = ({ options, value, setValue, style }) => {
  return (
    <div className="radio-picker" style={style}>
      {
        options.map((option) => (
          <div className={
            classNames(
              'radio-picker-option',
              { 'radio-picker-option-selected': value === option.label }
            )}
            key={option.value}
            onClick={() => setValue(option.label)}
          >
            <Typography
              color={value === option.label ? COLORS.PURPLE_PRIMARY_LITE : COLORS.TEXT_DISABLED_LITE}
              variant="text" size="xsmall" bold
              style={{ transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)' }}
            >
              <option.icon
                color={value === option.label ? COLORS.PURPLE_PRIMARY_LITE : COLORS.TEXT_DISABLED_LITE}
                size={16}
                weight="fill"
              />&nbsp;{option.label} 
            </Typography>
          </div>
        ))
      }
    </div>
  );
};

export default RadioPicker;